module.exports = {
  ...require('./public'),
  ...require('./pages'),
  ...require('./backend'),
};
